export default {
  comparand: '1rem'
}
